var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('youtube',{staticClass:"one-cms-youtube",attrs:{"video-id":_vm.getYoutubeId(_vm.videoId),"width":_vm.width,"height":_vm.height,"fit-parent":_vm.fitParent,"player-vars":_vm.$attrs}})
}
var staticRenderFns = []

export { render, staticRenderFns }